module.exports = __webpack_public_path__ + "static/img/14.2ba4e544.png";